import { BaseFetch } from "../main-model"
export default class ReportPerformanceModel extends BaseFetch {
    getReportPerformanceBy = (data) =>
    this.authFetch({
      url: "report-performance/getReportPerformanceBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
